<div class="static-pages-header">
  <div class="container">
    <div class="row">
      <div class="col-md-12 d-flex justify-content-center">
        <h1 class="static-pages__title">{{headerContent}}</h1>
      </div>
    </div>
  </div>
</div>
